"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
import { Component, Ref, Mixins } from "vue-property-decorator";
import DateFormat from "@/framework/timeformatter";
import BlockDialog from "@/components/layout/components/dialog/BlockDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
let MessageView = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.message_list = [];
    this.formatter = DateFormat;
  }
  mounted() {
    return __async(this, null, function* () {
      this.loading = true;
      try {
      } catch (error) {
      } finally {
        let _html = document.querySelector("html");
        if (_html) {
          _html.style.minWidth = "0px";
          _html.style.backgroundColor = "#fff";
        }
        let _body = document.querySelector("body");
        if (_body) {
          _body.style.minWidth = "0px";
          _body.style.backgroundColor = "#fff";
        }
        let _app = document.querySelector("#app");
        if (_app) {
          _app.style.minWidth = "0px";
          _app.style.backgroundColor = "#fff";
        }
        let response = yield API.get(
          `api://base.auth/api/v8/message_center/new_messages`
        );
        this.message_list = response.data.messageCenterResDtos;
        this.loading = false;
      }
    });
  }
  openNotice() {
    return __async(this, null, function* () {
      var _a;
      if ((_a = this.$session) == null ? void 0 : _a.marks.is("KV_INTERNAL_USER")) {
      } else {
        this._block_dialog.open();
      }
    });
  }
  allGetReadable() {
    return __async(this, null, function* () {
      try {
        this.loading = true;
        yield API.put(`api://base.auth/api/v8/message_center/change_reads`);
        let response = yield API.get(
          `api://base.auth/api/v8/message_center/new_messages`
        );
        this.message_list = response.data.messageCenterResDtos;
        this.loading = false;
      } catch (error) {
        this.message_list = [];
        this.loading = false;
      }
    });
  }
  toAllNews() {
    let _url = window.location.href.split("/message_view")[0];
    _url = _url + "/message_main";
    window.open(_url, "_blank");
  }
  checkreadable(item) {
    return __async(this, null, function* () {
      try {
        let _ids = [];
        _ids.push(item.guid);
        let response = yield API.put(
          `api://base.auth/api/v8/message_center/change_read`,
          {
            ids: _ids
          }
        );
        item.is_new = false;
        let _url = window.location.href.split("#/")[0];
        _url = _url + `#/message_detail?guid=${item.guid}`;
        window.open(_url, "_blank");
        console.log(response.data);
      } catch (error) {
      }
    });
  }
};
__decorateClass([
  Ref("blockDialog")
], MessageView.prototype, "_block_dialog", 2);
MessageView = __decorateClass([
  Component({
    components: {
      BlockDialog
    }
  })
], MessageView);
export {
  MessageView as default
};
